module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_3.2035d2e9.png";